import { createService } from '@betty/toolkit/api';
import {
  DepositCountSchema,
  UserBalancesSchema,
  CoinBalanceSchema,
  AvailablePaymentProvidersSchema,
} from './WalletService.schemas';

export default createService(
  {
    getDepositCount: {
      method: 'GET',
      url: '/successfulDepositCount',
      responseSchema: DepositCountSchema,
    },
    getCashBalance: {
      method: 'GET',
      url: '/balances',
      responseSchema: UserBalancesSchema,
    },
    getCoinBalance: {
      method: 'GET',
      url: '/coinbalance',
      responseSchema: CoinBalanceSchema,
    },
    getAvailablePaymentProviders: {
      method: 'GET',
      url: '/availablePaymentProviders',
      responseSchema: AvailablePaymentProvidersSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
